export default {
  path: '/profile_parameter_sets',
  name: 'profile_parameter_sets',
  component: () => import('../components/profileparameterset/Layout'),
  redirect: { name: 'ProfileParameterSetList' },
  meta: {
    breadcrumb: 'profile.profileparameter.sets',
  },
  children: [
    {
      name: 'ProfileParameterSetList',
      path: '',
      component: () => import('../views/profileparameterset/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ProfileParameterSetCreate',
      path: 'new',
      component: () => import('../views/profileparameterset/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ProfileParameterSetUpdate',
      path: ':id/edit',
      component: () => import('../views/profileparameterset/Update'),
      meta: {
        breadcrumb: 'profile.profileparameter.set',
      },
    },
    {
      name: 'ProfileParameterSetShow',
      path: ':id',
      component: () => import('../views/profileparameterset/Show'),
      meta: {
        breadcrumb: 'profile.profileparameter.set',
      },
    },
    {
      name: 'ProfileParameterSet',
      path: ':parent',
      component: () => import('../components/profileparametersetvalue/Layout'),
      meta: {
        breadcrumb: 'profile.profileparameter.set',
      },
      children: [
        {
          name: 'ProfileParameterSetValueShow',
          path: ':id',
          component: () => import('../views/profileparametersetvalue/Show'),
          meta: {
            breadcrumb: 'profile.profileparameter.values',
          },
        },
        {
          name: 'ProfileParameterSetValueUpdate',
          path: ':id/edit',
          component: () => import('../views/profileparametersetvalue/Update'),
          meta: {
            breadcrumb: 'profile.profileparameter.values',
          },
        },
        {
          name: 'ProfileParameterSetValueCreate',
          path: 'new',
          component: () => import('../views/profileparametersetvalue/Create'),
          meta: {
            breadcrumb: 'global.add',
          },
        },
      ]

    },
  ]
};
